import { render } from "./AppointmentCard.vue?vue&type=template&id=57d0de44&ts=true"
import script from "./AppointmentCard.vue?vue&type=script&lang=ts"
export * from "./AppointmentCard.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__